export const MUTED = 'rgb(var(--color-aqila-muted))';

export const INK = 'rgb(var(--color-aqila-ink))';

export const CHART_PALETTE = [
  'rgb(var(--color-aqila-chart-4))',
  'rgb(var(--color-aqila-chart-1))',
  'rgb(var(--color-aqila-chart-2))',
  'rgb(var(--color-aqila-chart-3))',
];

export const BAR_NAME_FONT_SIZE = 11;
export const BAR_NAME_CHAR_WIDTH = 6.4;
export const BAR_NAME_LINE_HEIGHT = 13;
export const BAR_NAME_MAX_LINES = 2;
export const BAR_NAME_OFFSET = 8;
export const BAR_SIZE = 22;
export const BAR_ROW_GAP = 14;
export const BAR_CHART_EXTRA_HEIGHT = 48;
export const BAR_CHART_MIN_HEIGHT = 160;
export const BAR_VALUE_SPACE = 76;
export const BAR_AXIS_WIDTH = 180;
export const BAR_AXIS_ROW_GAP = 30;
export const BAR_AXIS_CHART_MIN_HEIGHT = 260;
